import {cx} from "@emotion/css";
import $ from "jquery";
import {useEffect, useState} from "react";
import YouTube, {YouTubeEvent} from "react-youtube";

import {MediaVideoParameter} from "@/app/pages/upik/resources/ExportedTypes";
import {dnbComLog, isNotUndefinedOrNull, isUndefined, LogSeverity, TrustArcGroupId, trustArcGroupIsActive, videoTracking, windowOnLoadOrImmediate} from "@/shared/FunctionCore";
import {classCombinerFromPrefix, RenderableData, renderIdentifierGeneric} from "@/app/pages/upik/resources/RenderIdentifier";
import * as  MediaVideoStyles from "@/app/pages/upik/MediaVideo/MediaVideoStyles.module.scss";
import React from "react";

const styles = MediaVideoStyles;

const classCombiner = classCombinerFromPrefix("d29e73f064c73b05");

interface IFullWidthVedio {
    "fullwidthVideo"?: boolean;
}

type MediaVideoComponentProps = IFullWidthVedio & MediaVideoParameter;

const onPlay = (yo: YouTubeEvent) => {
    videoTracking(yo.target.videoTitle, "event7");
    yo.target.playVideo();
};
const onEnd = (yo: YouTubeEvent) => {
    videoTracking(yo.target.videoTitle, "event8");
};

export const MediaVideoComponent = (props: MediaVideoComponentProps): JSX.Element => {
    const {
        fullwidthVideo = false,
        showMissingVideoIdWarning,
        thumbnailImage,
        videoId,
        videoTitle
    } = props;

    const [play, setPlay] = useState(false);

    const [userHasGivenMarketingConsent, setUserHasGivenMarketingConsent] = useState(false);

    useEffect(() => {
        windowOnLoadOrImmediate(
            $(window),
            () => {
                try {
                    if (isNotUndefinedOrNull(trustArcGroupIsActive(TrustArcGroupId.trustArcGroupThree))) {
                        setUserHasGivenMarketingConsent(trustArcGroupIsActive(TrustArcGroupId.trustArcGroupThree));
                    }
                } catch (er) {
                    dnbComLog(LogSeverity.ERROR, "Video-error "+ er);
                }
            });
    }, []);

    return (
        isUndefined(videoId)
            ?
            (
                showMissingVideoIdWarning
                    ? <h2>
                        This component has not been configured with a YouTube video ID. This warning will not appear in production.
                    </h2>
                    : <></>
            )
            :
            <div className={cx(classCombiner(styles, fullwidthVideo ? "fullWidthMediaVideoWrapper" : "mediaVideoWrapper"))}>
                        {
                    isNotUndefinedOrNull(thumbnailImage) && !play
                        ?
                        <>
                                <div
                                className={cx(classCombiner(styles, "thumbnailIcon"))}
                                onClick={() => setPlay(true)} />

                                <div
                                className={cx(classCombiner(styles, "thumbnail"))}
                                style={
                                    {
                                        "backgroundImage": `url(${thumbnailImage})`
                                    }
                                }
                            />

                                <button
                                className={cx(classCombiner(styles, "thumbnailButton"))}
                                onClick={() => setPlay(true)}
                                type="button"
                            />
                            </>
                        :
                        (
                            userHasGivenMarketingConsent
                                ?
                                <YouTube
                                    // TODO videoWrapper
                                    className={cx("videoWrapper")}
                                    iframeClassName={cx(classCombiner(styles, "iframe"))}
                                    onEnd={(yo) => onEnd(yo)}
                                    onReady={(yo) => onPlay(yo)}
                                    opts={
                                        {
                                            "playerVars": {
                                                "autoplay": 1,
                                                "wmode": "opaque",
                                            },
                                        }
                                    }
                                    videoId={videoId}
                                />
                                :
                                // eslint-disable-next-line react/iframe-missing-sandbox
                                    <iframe
                                    allow="autoplay;fullscreen"
                                    // TODO ?
                                    // Does lazyload do anything?
                                    className={cx("lazyload", classCombiner(styles, "iframe"))}
                                    frameBorder="0"
                                    src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1`}
                                    // TODO Is this correct?
                                    title={videoTitle}
                                />
                        )
                }
                    </div>
    );
};

const mediaVideo = (renderableData: RenderableData<MediaVideoParameter>): void => renderIdentifierGeneric(MediaVideoComponent, renderableData);

export {mediaVideo};
